module.exports = __webpack_public_path__ + "static/media/Public_45.c72381cf.jpg";